<div class="flex items-center justify-center min-h-screen bg-white">
    <div class="flex flex-col items-center">
        <div class="relative w-full flex justify-center my-6">
            <!-- Left arrow -->
            <img
                src="/assets/images/shared/left-arrow-icon.png"
                alt="Back"
                class="h-5 w-auto absolute left-4 top-1/2 -translate-y-1/2 cursor-pointer"
                [routerLink]="['/landing']" />

            <!-- Logo -->
            <img src="/assets/images/auth/interseed-new-logo.png" alt="interseed logo" class="h-16 w-auto" />
        </div>

        <!-- Welcome Text -->
        <div class="text-center mt-6">
            <p class="text-[#0A0A0A] text-xl font-semibold">Welcome back!</p>
            <p class="text-[#717182] text-sm mt-2">Login to continue</p>
        </div>

        <!-- Auth Box -->
        <div
            class="w-full max-w-[600px] sm:min-w-[544px] rounded-[20px] border border-[#E2E8F0] bg-white/90 my-6 p-8 shadow-xl backdrop-blur">
            <form [formGroup]="loginForm" (ngSubmit)="submit()">
                <!-- Password Input -->
                <div class="flex flex-col mb-2 space-y-2">
                    <label for="password" class="text-xs text-[#0A0A0A] font-semibold uppercase">Password</label>
                    <div class="relative">
                        <input
                            id="password"
                            formControlName="password"
                            placeholder="Insert Password"
                            class="w-full form-field-container pr-10"
                            [type]="showPassword ? 'text' : 'password'" />
                        <img
                            alt="Toggle password visibility"
                            class="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 cursor-pointer"
                            [src]="
                                showPassword ? '/assets/images/auth/eye-hide.svg' : '/assets/images/auth/eye-show.svg'
                            "
                            (click)="togglePasswordVisibility()" />
                    </div>
                    <!-- Error message -->
                    @if (loginForm.get('password')?.invalid && loginForm.get('password')?.touched) {
                        <div class="text-[#717182] text-[0.625rem]">Must be at least 8 characters</div>
                    }
                </div>

                <p
                    class="text-[#4F66FF] text-[0.75rem] mb-4 cursor-pointer"
                    [routerLink]="['/forgot-password']"
                    [queryParams]="{ email }">
                    Forgot your password ?
                </p>
                <!-- Login Button -->
                <button type="submit" class="w-full border-button" [disabled]="loginForm.invalid">Log in</button>
            </form>
        </div>
    </div>
</div>
